import styled from "styled-components";
import Content from "components/templates/project";
import HEADER_HEIGHT from "components/atoms/headerHeight";

// 프로젝트 상세 페이지
const Project = () => {
  return (
    <Container>
      <Content />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: calc(100vh - ${HEADER_HEIGHT}px);
`;

export default Project;
